export const LYNNLIFE_STORE_URL = {
  android: "market://details?id=com.woomi.lynnlife",
  ios: "https://apps.apple.com/kr/app/id1559671877",
};

// 스마트린 앱 강제 업데이트 최소 버전 (외부 앱 연결 처리 및 Flutter 보안패치 적용 버전)
export const FORCE_UPDATE_MIN_APP_VERSION = "1.5.39";

// 현재버전 < 최소버전 이면 음수, 같으면 0, 현재버전 > 최소버전 이면 양수
export function compareVersion(currentVersion, targetVersion) {
  const currentParts = String(currentVersion)
    .split(".")
    .map((part) => parseInt(part, 10) || 0);
  const targetParts = String(targetVersion)
    .split(".")
    .map((part) => parseInt(part, 10) || 0);
  const maxLength = Math.max(currentParts.length, targetParts.length);

  for (let index = 0; index < maxLength; index++) {
    const diff = (currentParts[index] || 0) - (targetParts[index] || 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

export function getAppPlatform() {
  const browserInfo = navigator.userAgent.toLowerCase();
  if (browserInfo.indexOf("android") > 0) return "android";
  if (browserInfo.indexOf("iphone") > 0 || browserInfo.indexOf("ipad") > 0) {
    return "ios";
  }
  return "";
}

export function isFlutterApp() {
  return navigator.userAgent.toLowerCase().indexOf("wikey_flutter") > 0;
}
